module.exports = __webpack_public_path__ + "img/violet_142.334bc41f.png";